import { createSvgIcon } from '@mui/material';

const ArrowDown = createSvgIcon(<path d="M9 4H15V12H19.84L12 19.84L4.16 12H9V4Z" fill="currentColor" />, 'ArrowDown');

export default ArrowDown;
